import type { MRT_Cell, MRT_Row } from '@brightdrop/table-ui';
import type { User } from '@gm-commercial/profile-model';
import { Box, Typography } from '@mui/material';
import find from 'lodash/find';
import { Link, useParams } from 'react-router-dom';

import type { RouteParams } from '~/common/configs/route.config';
import { DEFAULT_EMPTY_VALUE } from '~/common/constants/common.constant';
import { RouteName } from '~/common/models/route.model';
import { makeRoutePathLite } from '~/common/utils/route/route.utils';
import { useOrganizationTenantsContext } from '~/features/users/list/OrganizationTenantsContext';

interface UserOrgColumnCellProps {
  cell: MRT_Cell<User, string>;
  row: MRT_Row<User>;
}

const UserOrgColumnCell = ({ row }: UserOrgColumnCellProps) => {
  const organizationsId = row.original?.organization?.id;
  const params = useParams<RouteParams>();
  const { tenants } = useOrganizationTenantsContext();
  const orgDetails = find(tenants, { id: organizationsId });
  const userDetailsLink = makeRoutePathLite({
    routeName: RouteName.ORGANIZATIONS_DETAILS,
    params: {
      ...params,
      organizationsId,
    },
  });
  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Box>
        <Typography variant="small_body_medium">
          {orgDetails?.name ? (
            <Link to={userDetailsLink} data-testid="user-list-org-name-link">
              {orgDetails.name}
            </Link>
          ) : (
            DEFAULT_EMPTY_VALUE
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default UserOrgColumnCell;
